import { PayloadAction } from '@reduxjs/toolkit';
import { TReactSelectOption } from '@ui/select/react-select/custom-react-select.types';
import { ContentReducerCreator } from '../types';

const setProductAttributesFilterReducer = (create: ContentReducerCreator) => {
  return create.reducer((state, action: PayloadAction<TReactSelectOption[]>) => {
    state.productAttributesFilter = action.payload;
  });
};

export default setProductAttributesFilterReducer;
